<template>
  <div>
    <h4>Roles Manager - FED Service Awards</h4>
    <h6>Edit Custom Role</h6>
    <p>Use this screen to edit custom roles and assign permissions to them.</p>
    <p class="text-danger">* These fields are required.</p>
    <div class="row m-1">
      <div class="col-xs-12 col-sm-12 col-lg-6 col-md-6 border p-3">
        <label for="name">Name*</label>
        <b-form-input
          class="my-2"
          v-model="roleName"
          name="name"
        ></b-form-input>
        <label for="roleDesc">Description*</label>
        <b-form-textarea
          class="my-2"
          v-model="roleDesc"
          rows="6"
          max-rows="6"
          name="roleDesc"
        ></b-form-textarea>
        <div class="form-inline my-2">
          <label for="adminAccess">Admin Access:</label>
          <div class="form-check form-switch mx-4">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              v-model="adminAccess"
              name="adminAccess"
              :value="adminAccess"
            />
            {{ adminAccess ? "On" : "Off" }}
          </div>
        </div>
      </div>
    </div>
    <div class="row m-1 my-2">
      <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12 border p-3">
        <label for="permissions">Permissions</label>
        <b-table-simple class="my-2" responsive>
          <b-thead>
            <b-tr>
              <b-th v-for="column in permissionsFields" :key="column.key">{{
                column.key
              }}</b-th>
            </b-tr>
          </b-thead>
          <b-tbody
            v-for="modules in getRolesListForSettingsAddRoleArr.client_modules"
            :key="modules.module_id"
          >
            <b-tr style="background: #ddd">
              <b-td>
                <p>{{ modules.module_name }}</p>
              </b-td>
              <b-td>
                <div class="form-check form-switch">
                  <input
                    v-model="moduleView"
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    :value="{ moduleId: modules.module_id }"
                    @change="toggleCheckBox('view', modules.module_id)"
                  />
                </div>
              </b-td>
              <b-td>
                <div class="form-check form-switch">
                  <input
                    v-model="moduleShow"
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    :value="{ moduleId: modules.module_id }"
                    @change="toggleCheckBox('show', modules.module_id)"
                  />
                </div>
              </b-td>
            </b-tr>
            <b-tr
              v-for="subModules in modules.sub_modules"
              :key="subModules.sub_module_id"
            >
              <b-td>
                <p class="mx-2">
                  <i class="fa-solid fa-caret-right"></i>
                  {{ subModules.sub_module_name }}
                </p>
              </b-td>
              <b-td>
                <div class="form-check form-switch">
                  <input
                    v-model="subModuleView"
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    :value="{
                      moduleId: modules.module_id,
                      subModuleId: subModules.sub_module_id,
                    }"
                    @change="
                      toggleCheckBox(
                        'view',
                        modules.module_id,
                        subModules.sub_module_id
                      )
                    "
                  />
                </div>
              </b-td>
              <b-td>
                <div class="form-check form-switch">
                  <input
                    v-model="subModuleShow"
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    :value="{
                      moduleId: modules.module_id,
                      subModuleId: subModules.sub_module_id,
                    }"
                    @change="
                      toggleCheckBox(
                        'show',
                        modules.module_id,
                        subModules.sub_module_id
                      )
                    "
                  />
                </div>
              </b-td>
            </b-tr>
          </b-tbody>
          <b-tbody
            v-if="getRolesListForSettingsAddRoleArr.client_modules.length < 0"
          >
            <div class="text-center my-2" style="color: #0d6efd">
              <strong class="mx-1">No data found.</strong>
            </div>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-4 col-md-1 col-lg-1">
        <b-button
          class="buttonStyle my-2"
          variant="primary"
          @click="saveRoles()"
        >
          Save</b-button
        >
      </div>
      <div class="col-xs-12 col-sm-4 col-md-3 col-lg-3">
        <b-button
          class="buttonStyle my-2"
          variant="primary"
          @click="saveRoles('return')"
        >
          Save and return</b-button
        >
      </div>
      <div class="col-xs-12 col-sm-4 col-md-1 col-lg-1 offset-md-6 offset-lg-6">
        <b-button
          class="buttonStyle my-2"
          variant="primary"
          :to="{ name: 'AdminSettingsRoleAndPermissions' }"
        >
          Cancel</b-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AdminSettingsRoleAndPermissionsEdit",

  props: {
    roleId: Number,
  },

  data() {
    return {
      roleName: "",
      roleDesc: "",
      adminAccess: true,
      permissionsFields: [
        {
          key: "Module / Submodule Name",
          sortable: true,
        },
        {
          key: "View",
          sortable: true,
        },
        {
          key: "Show / Hide",
          sortable: true,
        },
      ],
      moduleView: [],
      subModuleView: [],
      moduleShow: [],
      subModuleShow: [],
    };
  },

  methods: {
    saveRoles(from = "") {
      if (this.roleName && this.roleDesc && this.subModuleArr.length > 0) {
        // settings message to blank
        this.$store.commit("systemMessage/SET_MODAL_MESSAGE", "");

        // creating params
        var params = {
          client_role_id: this.getRolesListForSettingsAddRoleArr.client_role_id,
          client_id: +this.getUserClients.client,
          role_id: this.getRolesListForSettingsAddRoleArr.role_id,
          name: this.roleName,
          description: this.roleDesc,
          is_custom_role: this.getRolesListForSettingsAddRoleArr.is_custom
            ? this.getRolesListForSettingsAddRoleArr.is_custom
            : false,
          allows_admin_access: this.adminAccess ? true : false,
          overwrite_unit_roles: true,
          modules: this.modulesArr,
          sub_modules: this.subModuleArr,
        };

        // calling api
        this.$store
          .dispatch("settings/editCustomClientRoles", params)
          .then((result) => {
            // setting new data
            this.$store.dispatch("settings/fetchClientRolesByClientId", {
              clientRoleId: +this.$route.params.clientRoleId,
              clientId: +this.getUserClients.client,
            });

            if (result.status === 200 && from === "return") {
              // redirecting to list roles page
              this.$router.push({ name: "AdminSettingsRoleAndPermissions" });
            } else {
              this.scrollToTop();
            }
          })
          .catch(() => {
            console.log("error from edit saveRoles");
          });
      } else if (!this.roleName) {
        this.$store.commit(
          "systemMessage/SET_MODAL_MESSAGE",
          "Please enter the role name"
        );
      } else if (!this.roleDesc) {
        this.$store.commit(
          "systemMessage/SET_MODAL_MESSAGE",
          "Please enter the role description"
        );
      } else if (this.subModuleArr.length <= 0) {
        this.$store.commit(
          "systemMessage/SET_MODAL_MESSAGE",
          "Please turn on to view / show at least one submodule"
        );
      }
    },
    toggleCheckBox(type, moduleId, subModuleId = null) {
      if (type === "view") {
        if (subModuleId != null) {
          // trigerred from submodule
          var subModuleViewTemp = this.subModuleView.filter((v) => {
            return v.moduleId === moduleId;
          });

          if (subModuleViewTemp.length) {
            this.moduleView.push({ moduleId });
          } else {
            this.moduleView = this.moduleView.filter((v) => {
              return v.moduleId != moduleId;
            });
          }
        }
      } else if (type === "show") {
        if (subModuleId != null) {
          // trigerred from submodule
          var subModuleShowTemp = this.subModuleShow.filter((v) => {
            return v.moduleId === moduleId;
          });

          if (subModuleShowTemp.length) {
            this.moduleShow.push({ moduleId });
          } else {
            this.moduleShow = this.moduleShow.filter((v) => {
              return v.moduleId != moduleId;
            });
          }
        }
      }
    },
  },

  computed: {
    filterRecordsPerScreenOptions() {
      return this.$store.getters[
        "batchProcess/getFilterRecordsPerScreenOptions"
      ];
    },
    getUserClients() {
      return this.$store.getters["user/getUserClients"];
    },
    getRolesListForSettingsAddRoleArr() {
      return this.$store.getters["settings/getRolesListForSettingsAddRoleArr"];
    },
    modulesArr() {
      var arr = [];
      var show = this.moduleShow.map((v) => v.moduleId);
      var view = this.moduleView.map((v) => v.moduleId);

      arr = [...new Set([...show, ...view])];

      return arr.map((v) => {
        return {
          client_role_module_id: null,
          module_id: v,
          allow_view: view.includes(v),
          allow_show_hide: show.includes(v),
        };
      });
    },
    subModuleArr() {
      var arr = [];
      var show = Object.fromEntries(
        new Map(this.subModuleShow.map((v) => [v.subModuleId, v.moduleId]))
      );
      var view = Object.fromEntries(
        new Map(this.subModuleView.map((v) => [v.subModuleId, v.moduleId]))
      );

      arr = { ...show, ...view };
      var result = [];

      Object.entries(arr).forEach((e) => {
        var [sId, mId] = e;
        result.push({
          client_role_submodule_id: null,
          module_id: +mId,
          sub_module_id: +sId,
          allow_view: Object.keys(view).includes(sId),
          allow_show_hide: Object.keys(show).includes(sId),
        });
      });

      return result;
    },
  },
  watch: {
    getRolesListForSettingsAddRoleArr(getRolesListForSettingsAddRoleArr) {
      this.roleName = getRolesListForSettingsAddRoleArr.name;
      this.roleDesc = getRolesListForSettingsAddRoleArr.description;
      this.adminAccess = getRolesListForSettingsAddRoleArr.allow_admin_access
        ? true
        : false;

      getRolesListForSettingsAddRoleArr.client_modules.forEach((m) => {
        m.sub_modules.forEach((s) => {
          if (s.allow_view) {
            this.subModuleView.push({
              moduleId: m.module_id,
              subModuleId: s.sub_module_id,
            });
            this.toggleCheckBox("view", m.module_id, s.sub_module_id);
          }

          if (s.allow_show_hide) {
            this.subModuleShow.push({
              moduleId: m.module_id,
              subModuleId: s.sub_module_id,
            });
            this.toggleCheckBox("show", m.module_id, s.sub_module_id);
          }
        });
      });
    },
  },
  created() {
    this.$store.dispatch("settings/fetchClientRolesByClientId", {
      clientRoleId: +this.$route.params.clientRoleId,
      clientId: +this.getUserClients.client,
    });
  },
};
</script>
<style lang="scss" scoped>
.buttonStyle {
  border-radius: 1.5rem;
}
.form-switch .form-check-input {
  width: 2em;
  height: 1rem;
  margin-left: -1.5em !important;
}
</style>